import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiComplete } from "./api";
import { message } from "antd";
import { orderBy } from "lodash";

export const projectGetHotels = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(
        `/api/hmg/gethotelnames?id=${id}`,
        null,
        { headers: headers }
      );

      dispatch(apiComplete());
      if (!response.data.error) {
        return orderBy(response.data.data, [
          (hotel) => hotel.hotel_name.toLowerCase(),
        ]);
      }
      return [];
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiComplete());
      } else {
        message.error(err.message);
        dispatch(apiComplete());
      }
      return [];
    }
  };
};

export const projectGetIndexData = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.get(
        `/api/hmg/getindexes?id=${id}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(result.data,'result')
      dispatch(apiComplete());
      return result.data;
    } catch (error) {
      dispatch(apiComplete());
      message.error("Internal Server Error");
      return undefined;
    }
  };
};

export const projectSaveIndexAutoPopulateData = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.post(
        "/api/hmg/setindexmapping",
        params,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(params, result, "submit params");
      dispatch(apiComplete());
      message.success("Updated Successfully");
      return true;
    } catch (error) {
      dispatch(apiComplete());
      console.log(error);
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      return false;
    }
  };
};

export const projectGetAppConfiguration = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.get(
        `/api/hmg/app-configuration?id=${id}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(apiComplete());
      return result.data;
    } catch (error) {
      console.log(error.message);
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      dispatch(apiComplete());
      return undefined;
    }
  };
};

export const projectSetApplicationConfigurations = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.post(
        "/api/hmg/app-configuration",
        { ...params },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(result, "returned dataset");
      dispatch(apiComplete());
      return true;
    } catch (error) {
      console.log(error);
      dispatch(apiComplete());
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error"
      );
      return false;
    }
  };
};
